<div class="services-steps">
  <span class="services-steps__dot services-steps__dot--active">1</span>
  <span class="services-steps__line services-steps__line--half"></span>
  <span class="services-steps__dot">2</span>
</div>
<div class="services-steps__labels">
  <span>{{ leftLabel }}</span>
  <span>{{ rightLabel }}</span>
</div>
